import { useCart } from '@shopify/hydrogen-react'
import { Money } from '@shopify/hydrogen-react'
import Image from 'next/image'

import { AspectRatio } from '@/components/primitives/AspectRatio/AspectRatio'
import { Button } from '@/components/ui/button'

import { IMAGE_SIZE } from './Cart.constants'

import type { CartLineType } from './Cart.types'

export const RefillCartLineItem = ({ line }: { line: CartLineType }) => {
  const cart = useCart()

  const totalPrice = Number(line?.cost?.totalAmount?.amount)
  const subTotalPrice = Number(line?.cost?.subtotalAmount?.amount)
  const quantity = Number(line?.quantity)

  const isDiscounted = totalPrice < subTotalPrice

  const handleRemoveLineItem = () => {
    if (!line?.id) return

    cart?.linesRemove([line.id])
  }

  if (!quantity || !line?.id) return <></>

  return (
    <div className="flex flex-col gap-6">
      <div className="flex gap-4">
        {/* Image */}
        {line?.merchandise?.image?.url && (
          <div className="size-14">
            <AspectRatio ratio="1/1">
              <div className="relative size-full overflow-hidden rounded-sm border border-grey-300">
                <Image
                  src={line.merchandise.image.url}
                  alt={line.merchandise.image.altText || line.merchandise.title || ''}
                  fill
                  sizes={IMAGE_SIZE}
                  className="object-cover object-center"
                />
              </div>
            </AspectRatio>
          </div>
        )}

        {/* Product Details */}
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-2">
            <p className="text-sm font-medium">{line?.merchandise?.product?.title}</p>
            <div className="flex items-center gap-1">
              {line?.cost?.totalAmount && <Money data={line?.cost?.totalAmount} />}
              {line?.cost?.subtotalAmount && isDiscounted && <Money className="text-grey-400 line-through" data={line?.cost?.subtotalAmount} />} per unit
            </div>
          </div>
        </div>
      </div>
      {/* Remove Button */}
      <Button variant="solid" className="w-full" onClick={handleRemoveLineItem}>
        Remove Order Refill
      </Button>
    </div>
  )
}
